import httpStore from "@/api/httpStore.js";

export function getCoupons() {
  return httpStore.get(`/coupons`).then(res => {
    return res.data;
  });
}

export function getCoupon(id) {
  return httpStore.get(`/coupons/single/${id}`).then(res => {
    return res.data;
  });
}

export function getCouponProducts(id) {
  return httpStore.get(`/coupons/products/${id}`).then(res => {
    return res.data;
  });
}

export function addProductToCoupon(id, data) {
  return httpStore
    .post(`/coupons/product/${id}`, { product: data })
    .then(res => {
      return res.data;
    });
}

export function createCoupon(data) {
  return httpStore.post(`/coupons`, { coupon: data }).then(res => {
    return res.data;
  });
}

export function deleteCoupon(id) {
  return httpStore.delete(`/coupons/delete/${id}`).then(res => {
    return res.data;
  });
}

export function deleteProductFromCoupon(couponId, productId) {
  return httpStore
    .delete(`/coupons/product/${couponId}/${productId}`)
    .then(res => {
      return res.data;
    });
}

export function updateProductFromCoupon(couponId, productId, data) {
  return httpStore
    .put(`/coupons/product/${couponId}/${productId}`, { product: data })
    .then(res => {
      return res.data;
    });
}

export function updateCoupon(id, data) {
  return httpStore.put(`/coupons/update/${id}`, { coupon: data }).then(res => {
    return res.data;
  });
}

// Reglas de un cupón "by product" sobre una categoría completa (sin
// subcategoryId) o una subcategoría.
export function getCouponCategories(id) {
  return httpStore.get(`/coupons/categories/${id}`).then(res => {
    return res.data;
  });
}

export function addCategoryToCoupon(id, data) {
  return httpStore
    .post(`/coupons/category/${id}`, { category: data })
    .then(res => {
      return res.data;
    });
}

export function updateCategoryFromCoupon(couponId, ruleId, data) {
  return httpStore
    .put(`/coupons/category/${couponId}/${ruleId}`, { category: data })
    .then(res => {
      return res.data;
    });
}

export function deleteCategoryFromCoupon(couponId, ruleId) {
  return httpStore
    .delete(`/coupons/category/${couponId}/${ruleId}`)
    .then(res => {
      return res.data;
    });
}

// El endpoint pide el header de auth, así que el Excel se baja como blob con
// httpStore y la descarga se dispara a mano.
export function downloadCouponProductsExcel(id, code) {
  return httpStore
    .get(`/coupons/products_template/${id}`, { responseType: "blob" })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `coupon_${String(code || id).replace(
          /[^A-Za-z0-9_-]/g,
          "_"
        )}_products.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
}

// apply=false sólo valida y devuelve el resumen (added/updated/removed/errors)
export function uploadCouponProductsExcel(id, file, { apply, removeMissing }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("apply", apply ? "1" : "0");
  formData.append("removeMissing", removeMissing ? "1" : "0");
  return httpStore
    .post(`/coupons/products_upload/${id}`, formData)
    .then(res => res.data);
}
